export interface ApiUrlConfig {
  apiBaseUrl?: string;
  cableUrl?: string;
}

export interface ApiUrls {
  baseUrl(): string;
  url(path: string): string;
  v1(path: string): string;
  cableUrl(): string;
}

export function createApiUrls(config: ApiUrlConfig): ApiUrls {
  const baseUrl = (): string => config.apiBaseUrl?.trim() || window.location.origin;
  const url = (path: string): string => new URL(normalizedPath(path), baseUrl()).toString();

  return {
    baseUrl,
    url,
    v1: (path: string): string => url(`/api/v1/${path.replace(/^\/+/, '')}`),
    cableUrl: (): string => {
      const cableUrl = new URL('/cable', config.cableUrl || baseUrl());
      cableUrl.protocol = cableUrl.protocol === 'https:' || cableUrl.protocol === 'wss:' ? 'wss:' : 'ws:';

      return cableUrl.toString();
    }
  };
}

function normalizedPath(path: string): string {
  return path.startsWith('/') ? path : `/${path}`;
}
